export const evidenceFunctions = {}

evidenceFunctions.doNextStage = (obj) => {
  if (sessionStorage.getItem('token')) {
    //Configuración
    let config = {
      pathname: `/${obj.nextComponent}`,
      //pathname: `/DynamicFormComponent`,
      state: {
        stageName: obj.stageName,
        stageId: obj.stageId,
        stage: obj.stage,
        folioId: obj.folioId,
        actorId: obj.actorId,
        autoLoadVideo: obj.autoLoadVideo,
        audiob64: obj.audiob64,
        textAudio: obj.textAudio,
        textVideo: obj.textVideo,
        dateEvidence: obj.dateEvidence,
        videob64: obj.videob64,
        nameVideo: obj.nameVideo,
      }
    }

    //console.log(config)
    //Objeto lleno
    obj.navigate(config)
  }
  else {
    alert("No se encontró usuario.")
  }
}